<div class="otp-container">
  <div class="text-content">
    <h3>Verify Phone Number</h3>
    <p>We've sent a code to <br><strong>+91 {{ getMaskedPhoneNumber() }}</strong></p>
  </div>

  <div class="otp-input-wrapper">
    <input id="login_page_otp_input" type="tel" class="otp-field" [(ngModel)]="otpCode" (input)="onOtpChange()" maxlength="6"
      placeholder="• • • • • •" autocomplete="one-time-code">
  </div>

  <div class="timer-section">
    <p *ngIf="!canResend">Resend code in <span class="time">{{ countdown }}s</span></p>
    <ion-button id="login_page_resend_otp_button" *ngIf="canResend" fill="clear" (click)="resendCode()" class="resend-btn">
      Resend OTP
    </ion-button>
  </div>

  <ion-button id="login_page_verify_proceed_button" expand="block" shape="round" class="verify-btn" (click)="verifyOTP()" [disabled]="otpCode.length !== 6">
    <span *ngIf="!isLoading">Verify & Proceed</span>
    <ion-spinner *ngIf="isLoading" name="crescent"></ion-spinner>
  </ion-button>
</div>